import { Provider, inject } from '@angular/core';
import { USER_TOKEN_STORE } from '@tourfold/shared-kernels/auth';
import {
  FRONTEND_CONFIG_AUTH_ADAPTER,
  type FrontendConfigurationAuthAdapter,
} from '@tourfold/shared-kernels/frontend-configuration';
import { AuthService } from '../../services/auth.service';

/**
 * Wires the `FRONTEND_CONFIG_AUTH_ADAPTER` port for web-app.
 *
 * - `hasAccessToken` reads from `USER_TOKEN_STORE` so the kernel can decide between
 *   the public and authenticated endpoints on bootstrap without needing to
 *   import `AuthService`.
 * - `onTenantDiscovered` feeds the resolved tenant id back into `AuthService`
 *   so the legacy `setTenantId(...)` side effect (persist to localStorage,
 *   prime the in-memory cache) still fires.
 */
export const WEB_AUTH_FRONTEND_CONFIG_PROVIDERS: Provider[] = [
  {
    provide: FRONTEND_CONFIG_AUTH_ADAPTER,
    useFactory: (): FrontendConfigurationAuthAdapter => {
      const tokenStore = inject(USER_TOKEN_STORE);
      const authService = inject(AuthService);
      return {
        hasAccessToken: () => !!tokenStore.getAccessToken(),
        onTenantDiscovered: (tenantId) => {
          authService.setTenantId(tenantId);
        },
      };
    },
  },
];
